import {INewsList} from "../interfaces/news";
import {InjectionToken} from "@angular/core";

export const NEWS_INJECTION_TOKEN = new InjectionToken<INewsList>('news injection token');
